import type {GetStaticProps, InferGetStaticPropsType} from "next"

import datocms from "datasources/datocms"
import emptyStaticPaths from "lib/utils/emptyStaticPaths"

import type {GetCourseQuery, GetCourseQueryVariables} from "generated/datocms"
import {CoursePage} from "components/Course"
import {getCourseQuery} from "datasources/datocms/query"
import {exceptionsSlugs} from "pages/authorized/[userId]/courses/[slug]"
import {CoursePageProps} from "components/Course/CoursePageProps"

interface QueryParams {
  slug: string
}

export const getStaticPaths = emptyStaticPaths

export const getStaticProps: GetStaticProps<CoursePageProps> = async ({params}) => {
  const {slug} = params as unknown as QueryParams
  const response = await datocms<GetCourseQuery, GetCourseQueryVariables>(
    getCourseQuery,

    {
      filter: {
        slug: {
          eq: slug
        }
      }
    }
  )

  if (!response.course || (response.course.state !== "active" && !exceptionsSlugs.includes(slug))) {
    return {
      redirect: {
        permanent: false,
        destination: "/courses",
        courseState: null,
        curriculumCourse: null,
        curruculumStatus: null,
        userId: null
      }
    }
  }

  return {
    revalidate: 60,
    props: {
      isAuthenticated: false,
      course: response.course,
      courseState: null,
      curriculumCourse: null,
      curruculumStatus: null,
      userId: null
    }
  }
}

export default CoursePage
